import { DEFAULT_THEME_ID, type ThemeId } from './theme';

export type TLayout = 'quizheroes' | 'whitelabel';

export const THEMEABLE_LAYOUT: TLayout = 'whitelabel';

export function layoutFromTheme(themeId: ThemeId): TLayout {
  return themeId === DEFAULT_THEME_ID ? 'quizheroes' : 'whitelabel';
}

export function isThemeableLayout(layout: TLayout): boolean {
  return layout === THEMEABLE_LAYOUT;
}

export function isThemeableTheme(themeId: ThemeId): boolean {
  return themeId !== DEFAULT_THEME_ID;
}
